import { useTranslate } from '@refinedev/core';
import { Flex } from 'antd';
import { PresencePill } from '@/components/common/PresencePill';
import type { ContentProductListOut } from '@/api/generated/schemas';

/** Cover / master file, as two compact pills. */
export const ProductAssetsCell = ({
  record,
}: {
  record: ContentProductListOut;
}) => {
  const t = useTranslate();
  const f = (key: string) => t(`content_catalog.products.assets.${key}`);

  return (
    <Flex gap={4} wrap>
      <PresencePill present={!!record.is_cover_downloaded} label={f('cover')} />
      <PresencePill
        present={!!record.is_master_downloaded}
        label={f('master')}
      />
    </Flex>
  );
};
